export default __webpack_public_path__ + "static/media/user.5fc842e5.svg";